import { render, staticRenderFns } from "./Konfirmasi.vue?vue&type=template&id=12d7102c&"
import script from "./Konfirmasi.vue?vue&type=script&lang=ts&"
export * from "./Konfirmasi.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports